const config = {
    "is a required property": "必填",
    "error.required": "必填",
}

const translator = (key, defaultMessage) => {
    // console.debug( `${key} --> ${defaultMessage}` );
    return config[key] || defaultMessage;
};

export default translator